
import React, { createContext, useState } from "react";
import FreeTrial from "./components/Landing_Page/Home_Page/FreeTrial";

const MyContext = createContext();

export const MyContextProvider = ({ children }) => {
 const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);
 const [currentPageKey, setCurrentPageKey] = useState("");

  const openFreeTrialModal = (pageKey) => {
  if (!pageKey) return;
  setCurrentPageKey(pageKey);
  setShowFreeTrialModal(true);
};

 const closeFreeTrialModal = () => {
    setShowFreeTrialModal(false);
  };

  // API configs (same as your code)
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? "https://api.anlook.com"
         : "https://api.anlook.com"; 

             // : "https://payinnew.remittpe.com";


  const baseUrl2 = "https://openApi.Dhroom.com";

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
    },
  };

  const config2 = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
      "Client-Id": "Whatsappbulksend",
    },
  };

  return (
    <MyContext.Provider
      value={{
        baseUrl,
        baseUrl2,
        config,
        config2,
         openFreeTrialModal,
        closeFreeTrialModal
      }}
    >
      {children}

      {/* Free Trial Modal */}
          <FreeTrial
        show={showFreeTrialModal}
        handleClose={closeFreeTrialModal}
        pageKey={currentPageKey}
      />
    </MyContext.Provider>
  );
};

export default MyContext;